import { render, staticRenderFns } from "./Annotate.vue?vue&type=template&id=cfb545c2&scoped=true&lang=pug"
import script from "./Annotate.vue?vue&type=script&lang=ts"
export * from "./Annotate.vue?vue&type=script&lang=ts"
import style0 from "./Annotate.vue?vue&type=style&index=0&id=cfb545c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb545c2",
  null
  
)

export default component.exports